import { Navigate } from "@tanstack/react-router";

export const Route = createFileRoute({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  return <Navigate to="/$orgId/dashboard" params={{ orgId: orgId }} />;
}
